<template>
    <div class="board" v-if="formData && errorData">
        <div class="bar">
            <b-icon icon="card-text" class="icon"></b-icon>
            <span>เทิร์นอะไหล่</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <perfect-scrollbar class="mb-4">
                <table v-if="formData.turnPartList.length > 0">
                    <thead>
                        <tr>
                            <th>อะไหล่เทิร์น</th>
                            <th class="text-right">ราคาเทิร์น</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in formData.turnPartList" :key="index">
                            <td>
                                <div class="turnpart-field">
                                    <button class="btn btn-red btn-sm" @click="removeTurnPart(index)">ลบ</button>
                                    <input type="text"
                                        v-model="item.name"
                                        class="input-field text-right"
                                        :class="{ 'invalid': errorData.turnPartList.name.find(x => x.blankIndex === index) }"
                                        :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                        maxlength="100"
                                        placeholder="ชื่ออะไหล่" />
                                </div>
                                <div class="input-error-message" v-if="errorData.turnPartList.name.find(x => x.blankIndex === index)">โปรดระบุชื่ออะไหล่</div>
                            </td>
                            <td>
                                <input type="tel"
                                    v-model="item.price"
                                    class="input-field text-right"
                                    :class="{ 'invalid': errorData.turnPartList.price.find(x => x.blankIndex === index) }"
                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    maxlength="6"
                                    @keypress="$AppUtility.inputOnlyNumber($event)"
                                    placeholder="ราคา" />
                                <div class="input-error-message" v-if="errorData.turnPartList.price.find(x => x.blankIndex === index)">โปรดระบุราคา</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <div class="no-data" v-if="formData.turnPartList.length === 0">
                <b-icon icon="exclamation-diamond"></b-icon>
                <span>ไม่มีรายการเทิร์นอะไหล่</span>
            </div>

            <div class="text-center" v-if="jobState !== $Constants.JOB_STATUS_COMPLETE">
                <button class="btn btn-dash btn-block btn-grey-outline" @click="addTurnPart()">เพิ่มรายการเทิร์นอะไหล่</button>
            </div>
        </div>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';
import MixinFormData from '@/components/job/FormData';
import Helper from '@/resources/Helper';

export default {
    mixins: [ MixinThemeBoard, MixinFormData],
    data() {
        return {
            formData: null
        }
    },
    props: {
        jobState: Number,
        loadData: Object,
        errorData: Object
    },
    mounted() {
        this.pageLoad();
    },
    methods: {
        pageLoad() {
            this.formData = this.initForm();

            if (this.loadData) {
                this.loadTurnPartList();
            }

            this.$emit('formData', this.formData);
        },
        initForm() {
            return {
                turnPartList: [],
            };
        },
        loadTurnPartList() {
            this.formData.turnPartList = Helper.cloneObject(this.loadData.turnPartList);
        },
        addTurnPart() {
            this.formData.turnPartList.push({
                name: '',
                price: ''
            })
        },
        removeTurnPart(index) {
            if (this.jobState !== this.$Constants.JOB_STATUS_COMPLETE) {
                this.formData.turnPartList.splice(index, 1);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
table {
    td {
        .turnpart-field {
            position: relative;
            display: flex;
            align-items: center;

            .btn {
                position: absolute;
                left: 10px;
            }
        }
    }
}
</style>